// extracted by mini-css-extract-plugin
export default {"root":"MessageSmoothing_root__cWQ85","container":"MessageSmoothing_container__03+wq","title":"MessageSmoothing_title__rLT4N","message":"MessageSmoothing_message__OzGSD"};